// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__wPG+8","text":"NotFound_text__GYd+S"};